import { doc, getDoc } from "firebase/firestore"
import { db } from "@/lib/firebase"

export interface FilterTattooStyle {
  downloadUrl: string
  styleId: string
  styleName: string
}

export interface DynamicFeedData {
  filterCity: string[]
  filterTattooStyle: Array<{
    downloadUrl: string
    styleId: string
    styleName: string
  }>
}

export async function fetchDynamicFeedData(): Promise<DynamicFeedData | null> {
  try {
    const docRef = doc(db, "dynamicData", "feed")
    const docSnap = await getDoc(docRef)
    
    if (!docSnap.exists()) {
      console.warn("Dynamic feed data document does not exist")
      return null
    }

    const data = docSnap.data()
    
    const filterTattooStyleArray = Object.values(data.filterTattooStyle || {}) as Array<{
      downloadUrl: string
      styleId: string
      styleName: string
    }>

    return {
      filterCity: data.filterCity || [],
      filterTattooStyle: filterTattooStyleArray
    }
  } catch (error) {
    console.error("Error fetching dynamic feed data:", error)
    return null
  }
} 